import React from 'react';
import { Dialog, DialogBody, DialogHeader } from '../../components/ui';
import { ConfidentialityPanel } from './ConfidentialityPanel';
import type { AccessSummary, GrantEntityType } from './types';

/**
 * The level and access panel in a sheet, for records that have no page of
 * their own — a stance lives on a board card, not at a URL.
 */
export const ConfidentialityDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  entityType: GrantEntityType;
  entityId: string;
  /** What the record is, for the dialog title */
  label?: string;
  onChanged?: (summary: AccessSummary) => void;
}> = ({ open, onClose, entityType, entityId, label, onChanged }) => (
  <Dialog
    open={open}
    onClose={onClose}
    labelledBy="confidentiality-dialog-title"
    handle
    className="sm:max-w-md"
  >
    <DialogHeader
      id="confidentiality-dialog-title"
      title={label ? `Access · ${label}` : 'Access'}
    />
    <DialogBody className="pb-5">
      {open && (
        <ConfidentialityPanel
          entityType={entityType}
          entityId={entityId}
          onChanged={onChanged}
          className="!border-0"
        />
      )}
    </DialogBody>
  </Dialog>
);

export default ConfidentialityDialog;
